import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { BsTextareaT } from "react-icons/bs";
import { setTextBoxCoordinates } from "../../redux/slices/textBoxCoordinatesReducer";
import { setActiveCoordinate } from "../../redux/slices/activeCoordinateReducer";
import { FieldTypeEnum } from "../../constants/fieldTypeEnum";
import { ShowToast } from "../../utils/showToast";
import { ToastTypeEnum } from "../../constants/toastTypeEnum";

function TextBoxButtonContainer({ documentBounding }) {
  const dispatch = useDispatch();
  const supportedFields = useSelector((state) => state.supportedFields.supportedFields);
  const activeSignatory = useSelector((state) => state.activeSignatory.activeSignatory);
  const activePageNumber = useSelector((state) => state.activePageNumber.activePageNumber);
  const textBoxCoordinates = useSelector((state) => state.textBoxCoordinates.textBoxCoordinates);
  const signatureCoordinates = useSelector((state) => state.signatureCoordinates.signatureCoordinates);
  const dateCoordinates = useSelector((state) => state.dateCoordinates.dateCoordinates);
  const checkBoxCoordinates = useSelector((state) => state.checkBoxCoordinates.checkBoxCoordinates);
  const emailBoxCoordinates = useSelector((state) => state.emailBoxCoordinatesReducer?.emailBoxCoordinates || []);
  const picklistCoordinates = useSelector((state) => state.picklistCoordinates.picklistCoordinates);

  const allCoordinates = [
    ...signatureCoordinates,
    ...textBoxCoordinates,
    ...dateCoordinates,
    ...checkBoxCoordinates,
    ...emailBoxCoordinates,
    ...picklistCoordinates,
  ];

  const isOverlapping = (newEle) => {
    return allCoordinates.some((coord) => {
      if (coord.pageId !== newEle.pageId) return false;
      return (
        newEle.x + 2 < coord.x + coord.width &&
        newEle.x + newEle.width - 2 > coord.x &&
        newEle.y + 2 < coord.y + coord.height &&
        newEle.y + newEle.height - 2 > coord.y
      );
    });
  };

  const pageDimensions = useSelector((state) => state.generalDocument?.pageDimensions);
  const canvasW = pageDimensions?.width || 595;
  const canvasH = pageDimensions?.height || 840;

  const onDragEnd = (event) => {
    
    console.log("Drag ended:", event);
    
    try{
    const field = supportedFields.find(
      (field) => field.type === FieldTypeEnum.TEXT
    );
    const coordsLength = textBoxCoordinates.length;

    const pagex = event.pageX - documentBounding.left - field.width / 2;
    
    const pagey = event.pageY - documentBounding.top - field.height / 2;
    console.log('page y' + pagey);

    const pageScreenX = event.screenX - documentBounding.left - field.width / 2;
    const pageScreenY = event.screenY - documentBounding.top - field.width / 2;

    console.log('page screen x text' + pageScreenX);
    console.log('page screen y text' + pageScreenY);

    // console.log('page screen' + pageScreen);
    
    

    let newEle = {
      field_id: field.id,
      value: "",
      signatory_id: activeSignatory.id,
      user_index_id: activeSignatory.index,
      bgColor: activeSignatory.bgColor,
      name: `Text${coordsLength + 1}`,
      eleId: `textEle${coordsLength}`,
      pageId: activePageNumber,
      x: pagex < 0 ? 0 : pagex > canvasW - field.width ? canvasW - field.width : pagex,
      y: pagey < 0 ? 0 : pagey > canvasH - field.height ? canvasH - field.height : pagey,
      screenX: pageScreenX,
      screenY: pageScreenY,
      width: field.width,
      height: field.height,
      isRequired: true,
      // writeBack: false,
      // updateFromSalesforce: false,
      editable:true,
      mappingField: { label: "", value: "", type: "" }, // UI-only state, stripped before API call
      maxLength: 255,
    };

     if (isOverlapping(newEle)) {
        ShowToast(ToastTypeEnum.ERROR, "Cannot place input on top of another input.");
        return;
      }


    dispatch(
      setTextBoxCoordinates({
        textBoxCoordinates: textBoxCoordinates.concat(newEle),
      })
    );
    dispatch(
      setActiveCoordinate({ activeCoordinate: newEle, isSelectionMode: true })
    );
  }catch(e){
    console.log('@@@ ERROR::'+e.message);  
    localStorage.setItem('unexpected-error',e.stack)
    window.location.href='/unexpected-error'    
    throw new Error(e.message);
  };
  };

  return ( 
    <button type="button" className="tool-btn" onDragEnd={onDragEnd} draggable>
      <BsTextareaT className="tool-icon" /> <p>Text</p>
    </button>
  );
}

export default TextBoxButtonContainer;
